module.exports = __webpack_public_path__ + "img/baza-logo.0210f9d5.svg";